import { useEffect } from "react";
import { AlphanumericField } from "../../../../utils/form";
import _ from "lodash";

const InsuranceNumberInput = ({ form }) => {
  const { control, setValue, watch } = form;
  const healthInsurance = watch("healthInsurance");
  const isCustomHealthInsurance = watch("isCustomHealthInsurance");

  const isParticular = _.lowerCase(healthInsurance) == "particular";
  const isOptional = isParticular || isCustomHealthInsurance;

  useEffect(() => {
    if (isParticular) {
      setValue("insuranceNumber", "");
    }
  }, [isParticular, setValue]);

  return (
    <AlphanumericField
      control={control}
      fullWidth
      name="insuranceNumber"
      label="Número de afiliado"
      variant="outlined"
      required={!isOptional}
      disabled={isParticular}
    />
  );
}

export default InsuranceNumberInput;
